import React, { useState } from 'react';
import { Modal } from '../common/Modal';
import { useToast } from '../../hooks/useToast';
import { feasibilityAssessmentServices } from '../../APIServices/feasibilityAssessmentServices';

function FeasibilityCreateModal({ open, onClose, onCreated, studyOptions = [] }) {
  const toast = useToast();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [form, setForm] = useState({
    code: '',
    title: '',
    studyId: '',
    cros: 'BioServe Clinical, Medanta Research',
    dueAt: ''
  });

  const submit = () => {
    if (!form.title || !form.studyId || !form.cros) {
      toast('Title, study and CROs are required', 'warn');
      return;
    }

    createFeasibility();
  };

  const createFeasibility = async () => {
    setButtonLoader(true);
    try {
      const payload = {
        code: form.code,
        title: form.title,
        studyId: form.studyId,
        cros: form.cros,
        dueAt: form.dueAt ? new Date(form.dueAt).toISOString() : null,
        template: 'std_babe_v3',
      };

      const data = await feasibilityAssessmentServices.addNewFeasibilityAssessment(payload);
      const newFeasibility = data?.data || {};
      toast(`Feasibility ${newFeasibility?.code || payload.code || ''} created`, 'ok');

      setForm({
        code: '',
        title: '',
        studyId: '',
        cros: 'BioServe Clinical, Medanta Research',
        dueAt: ''
      });

      onClose();
      onCreated?.(newFeasibility?.assessmentId);
    } catch (error) {
      toast('Unable to create feasibility assessment.', 'warn');
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="New feasibility assessment"
      footer={
        <>
          <button className="btn" onClick={onClose}>Cancel</button>
          {buttonLoader ? (
            <button className="btn btn-primary" disabled><div className='buttonLoader' /> Create</button>
          ) : (
            <button className="btn btn-primary" onClick={submit}>
              <i className="ti ti-check" /> Create
            </button>
          )}
        </>
      }
    >
      <div className="field-row">
        <div className="field">
          <label className="field-label">Code</label>
          <input value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} placeholder="Auto-generated if empty" />
        </div>
        <div className="field">
          <label className="field-label">Due date</label>
          <input type="date" value={form.dueAt} onChange={(e) => setForm({ ...form, dueAt: e.target.value })} />
        </div>
      </div>

      <div className="field">
        <label className="field-label">Title <span className="req">*</span></label>
        <input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} placeholder="e.g. Apixaban 5mg BABE — CRO selection" />
      </div>

      <div className="field">
        <label className="field-label">Linked study <span className="req">*</span></label>
        <select value={form.studyId} onChange={(e) => setForm({ ...form, studyId: e.target.value })}>
          <option value="">Select study...</option>
          {studyOptions.map((s) => (
            <option key={s.studyId} value={s.studyId}>{s.studyCode} · {s.moleculeProduct}</option>
          ))}
        </select>
      </div>

      <div className="field">
        <label className="field-label">CROs to evaluate (comma-separated) <span className="req">*</span></label>
        <input value={form.cros} onChange={(e) => setForm({ ...form, cros: e.target.value })} />
      </div>

      <div className="field-hint">Template: Standard BABE Feasibility v3 (7 sections, 13 questions)</div>
    </Modal>
  );
}

export default FeasibilityCreateModal;